(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        var _this = this;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.SIZE = 4;
        this.score = 0;
        this.status = "playing";
        this.board = Array.from({
            length: this.SIZE
        }, function() {
            return Array(_this.SIZE).fill(0);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "_addRandomTile",
            value: function _addRandomTile() {
                var emptyCells = [];
                for(var r = 0; r < this.SIZE; r++){
                    for(var c = 0; c < this.SIZE; c++)if (this.board[r][c] === 0) emptyCells.push({
                        row: r,
                        col: c
                    });
                }
                if (emptyCells.length === 0) return;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var _emptyCells_randomIndex = emptyCells[randomIndex], row = _emptyCells_randomIndex.row, col = _emptyCells_randomIndex.col;
                var newValue = Math.random() < 0.9 ? 2 : 4;
                this.board[row][col] = newValue;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                var ifChanged = false;
                this.board.forEach(function(row, index) {
                    var beforeRes = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                    var withoutZeros = row.filter(function(num) {
                        return num !== 0;
                    });
                    for(var i = 0; i < withoutZeros.length - 1; i++)if (withoutZeros[i] === withoutZeros[i + 1]) {
                        withoutZeros[i] = withoutZeros[i] + withoutZeros[i + 1];
                        _this.score += withoutZeros[i];
                        withoutZeros[i + 1] = 0;
                        i++;
                    }
                    var withoutZerosFinal = withoutZeros.filter(function(num) {
                        return num !== 0;
                    });
                    while(withoutZerosFinal.length < 4)withoutZerosFinal.push(0);
                    var changed = beforeRes.some(function(val, indx) {
                        return val !== withoutZerosFinal[indx];
                    });
                    if (changed) ifChanged = true;
                    _this.board[index] = withoutZerosFinal;
                });
                if (ifChanged) this._addRandomTile();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                var ifChanged = false;
                this.board.forEach(function(row, index) {
                    var beforeRes = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                    var reversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                    var withoutZeros = reversed.filter(function(num) {
                        return num !== 0;
                    });
                    for(var i = 0; i < withoutZeros.length - 1; i++)if (withoutZeros[i] === withoutZeros[i + 1]) {
                        withoutZeros[i] = withoutZeros[i] + withoutZeros[i + 1];
                        _this.score += withoutZeros[i];
                        withoutZeros[i + 1] = 0;
                        i++;
                    }
                    var withoutZerosFinal = withoutZeros.filter(function(num) {
                        return num !== 0;
                    });
                    while(withoutZerosFinal.length < 4)withoutZerosFinal.push(0);
                    withoutZerosFinal = withoutZerosFinal.reverse();
                    var changed = beforeRes.some(function(val, indx) {
                        return val !== withoutZerosFinal[indx];
                    });
                    if (changed) ifChanged = true;
                    _this.board[index] = withoutZerosFinal;
                });
                if (ifChanged) this._addRandomTile();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this;
                var ifChanged = false;
                var transposed = [
                    [],
                    [],
                    [],
                    []
                ];
                for(var i = 0; i < this.board.length; i++)for(var j = 0; j < this.board[i].length; j++)transposed[j][i] = this.board[i][j];
                transposed.forEach(function(row, index) {
                    var beforeRes = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                    var withoutZeros = row.filter(function(num) {
                        return num !== 0;
                    });
                    for(var i = 0; i < withoutZeros.length - 1; i++)if (withoutZeros[i] === withoutZeros[i + 1]) {
                        withoutZeros[i] = withoutZeros[i] + withoutZeros[i + 1];
                        _this.score += withoutZeros[i];
                        withoutZeros[i + 1] = 0;
                        i++;
                    }
                    var withoutZerosFinal = withoutZeros.filter(function(num) {
                        return num !== 0;
                    });
                    while(withoutZerosFinal.length < 4)withoutZerosFinal.push(0);
                    var changed = beforeRes.some(function(val, indx) {
                        return val !== withoutZerosFinal[indx];
                    });
                    if (changed) ifChanged = true;
                    transposed[index] = withoutZerosFinal;
                });
                for(var i1 = 0; i1 < 4; i1++)for(var j1 = 0; j1 < 4; j1++)this.board[i1][j1] = transposed[j1][i1];
                if (ifChanged) this._addRandomTile();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this;
                var ifChanged = false;
                var transposed = [
                    [],
                    [],
                    [],
                    []
                ];
                for(var i = 0; i < this.board.length; i++)for(var j = 0; j < this.board[i].length; j++)transposed[j][i] = this.board[i][j];
                transposed.forEach(function(row, index) {
                    var beforeRes = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                    var reversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                    var withoutZeros = reversed.filter(function(num) {
                        return num !== 0;
                    });
                    for(var i = 0; i < withoutZeros.length - 1; i++)if (withoutZeros[i] === withoutZeros[i + 1]) {
                        withoutZeros[i] = withoutZeros[i] + withoutZeros[i + 1];
                        _this.score += withoutZeros[i];
                        withoutZeros[i + 1] = 0;
                        i++;
                    }
                    var withoutZerosFinal = withoutZeros.filter(function(num) {
                        return num !== 0;
                    });
                    while(withoutZerosFinal.length < 4)withoutZerosFinal.push(0);
                    withoutZerosFinal = withoutZerosFinal.reverse();
                    var changed = beforeRes.some(function(val, indx) {
                        return val !== withoutZerosFinal[indx];
                    });
                    if (changed) ifChanged = true;
                    transposed[index] = withoutZerosFinal;
                });
                for(var i1 = 0; i1 < 4; i1++)for(var j1 = 0; j1 < 4; j1++)this.board[i1][j1] = transposed[j1][i1];
                if (ifChanged) this._addRandomTile();
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    if (this.board[row][col] === 0) return false;
                }
                for(var row1 = 0; row1 < 4; row1++)for(var col1 = 0; col1 < 4; col1++){
                    if (col1 < 3 && this.board[row1][col1] === this.board[row1][col1 + 1]) return false;
                    if (row1 < 3 && this.board[row1][col1] === this.board[row1 + 1][col1]) return false;
                }
                this.status = "lose";
                return true;
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.board[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var row = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = row[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var cell = _step1.value;
                                if (cell === 2048) {
                                    this.status = "win";
                                    document.querySelector(".message-win").classList.remove("hidden");
                                    return;
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "updateScore",
            value: function updateScore() {
                var uiScore = document.querySelector(".game-score");
                uiScore.textContent = this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                this.score = 0;
                this.status = "playing";
                this.board = Array.from({
                    length: this.SIZE
                }, function() {
                    return Array(_this.SIZE).fill(0);
                });
                this._addRandomTile();
                this._addRandomTile();
                var start = document.querySelector(".start");
                var startMessage = document.querySelector(".message-start");
                start.classList.remove("start");
                start.classList.add("restart");
                start.textContent = "Restart";
                startMessage.classList.add("hidden");
            }
        },
        {
            key: "restart",
            value: function restart() {
                var _this = this;
                this.score = 0;
                this.status = "playing";
                this.board = Array.from({
                    length: this.SIZE
                }, function() {
                    return Array(_this.SIZE).fill(0);
                });
                var restart = document.querySelector(".restart");
                var startMessage = document.querySelector(".message-start");
                var loseMessage = document.querySelector(".message-lose");
                var winMessage = document.querySelector(".message-win");
                loseMessage.classList.add("hidden");
                startMessage.classList.remove("hidden");
                winMessage.classList.add("hidden");
                restart.classList.add("start");
                restart.classList.remove("restart");
                restart.textContent = "Start";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startBtn = document.querySelector(".button.start");
function $197cd56b15c33885$var$render() {
    var cells = document.querySelectorAll(".field-cell");
    for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
        var index = row * 4 + col;
        var value = $197cd56b15c33885$var$game.board[row][col];
        var cell = cells[index];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add("field-cell--".concat(value));
    }
}
function $197cd56b15c33885$var$lose() {
    if ($197cd56b15c33885$var$game.checkLose()) {
        var loseMessage = document.querySelector(".message-lose");
        loseMessage.classList.remove("hidden");
    }
}
function $197cd56b15c33885$var$win() {
    if ($197cd56b15c33885$var$game.checkWin()) {
        var winMessage = document.querySelector(".message-win");
        winMessage.classList.remove("hidden");
    }
}
$197cd56b15c33885$var$startBtn.addEventListener("click", function() {
    if ($197cd56b15c33885$var$startBtn.classList.contains("restart")) $197cd56b15c33885$var$game.restart();
    else $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$render();
    $197cd56b15c33885$var$game.updateScore();
});
document.addEventListener("keydown", function(ev) {
    if (ev.key === "ArrowLeft") {
        $197cd56b15c33885$var$game.moveLeft();
        $197cd56b15c33885$var$render();
        $197cd56b15c33885$var$game.updateScore();
        $197cd56b15c33885$var$lose();
        $197cd56b15c33885$var$win();
    }
    if (ev.key === "ArrowRight") {
        $197cd56b15c33885$var$game.moveRight();
        $197cd56b15c33885$var$render();
        $197cd56b15c33885$var$game.updateScore();
        $197cd56b15c33885$var$lose();
        $197cd56b15c33885$var$win();
    }
    if (ev.key === "ArrowUp") {
        $197cd56b15c33885$var$game.moveUp();
        $197cd56b15c33885$var$render();
        $197cd56b15c33885$var$game.updateScore();
        $197cd56b15c33885$var$lose();
        $197cd56b15c33885$var$win();
    }
    if (ev.key === "ArrowDown") {
        $197cd56b15c33885$var$game.moveDown();
        $197cd56b15c33885$var$render();
        $197cd56b15c33885$var$game.updateScore();
        $197cd56b15c33885$var$lose();
        $197cd56b15c33885$var$win();
    }
});

})();
//# sourceMappingURL=index.128b8c97.js.map
